/* Trevit native home sections */
(function () {
  if (window.__tvHome) return; window.__tvHome = true;

  // Tabs
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-tv-tab]');
    if (!btn) return;
    var root = btn.closest('[data-tv-tabs]');
    root.querySelectorAll('[data-tv-tab]').forEach(function (b) { b.setAttribute('aria-selected', b === btn ? 'true' : 'false'); });
    root.querySelectorAll('[data-tv-panel]').forEach(function (p) { p.hidden = p.id !== btn.getAttribute('aria-controls'); });
  });

  // YouTube click-to-load
  document.addEventListener('click', function (e) {
    var yt = e.target.closest('[data-tv-yt]');
    if (!yt || yt.querySelector('iframe')) return;
    var id = yt.getAttribute('data-tv-yt');
    yt.innerHTML = '<iframe src="https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0" title="YouTube video" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>';
  });


  // Video reels (testimonials)
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-tv-reel]'); if (!b) return;
    var item = b.closest('.tv-reel__item'), v = item.querySelector('video');
    document.querySelectorAll('.tv-reel__item.is-playing video').forEach(function (o) { if (o !== v) { o.pause(); o.closest('.tv-reel__item').classList.remove('is-playing'); o.controls = false; } });
    item.classList.add('is-playing'); v.controls = true; v.muted = false; v.play();
  });
  // Carousel arrows
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-tv-carousel] .tv-carousel__btn'); if (!b) return;
    var t = b.parentElement.querySelector('.tv-carousel__track'), it = t.firstElementChild;
    var step = it ? it.getBoundingClientRect().width + 16 : 300;
    t.scrollBy({ left: step * (+b.dataset.dir), behavior: 'smooth' });
  });


  // Arrow buttons that scroll the track sitting between them
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-tv-scroll]'); if (!b) return;
    var t = [].find.call(b.parentElement.children, function (c) { return !c.classList.contains('tv-arrow'); });
    if (t) t.scrollBy({ left: t.clientWidth * 0.8 * (+b.dataset.tvScroll), behavior: 'smooth' });
  });
  // Dots for swipe areas
  function setupDots(el) {
    if (el.__dots) return; el.__dots = true;
    var dots = el.nextElementSibling; if (!dots || !dots.classList.contains('tv-dots')) return;
    function build() {
      var pages = Math.ceil((el.scrollWidth - 4) / el.clientWidth);
      dots.hidden = pages < 2; if (pages < 2) return;
      if (dots.children.length !== pages) {
        dots.innerHTML = '';
        for (var i = 0; i < pages; i++) { var d = document.createElement('button'); d.type = 'button'; d.setAttribute('aria-label', 'Go to slide ' + (i + 1)); (function (n) { d.addEventListener('click', function () { el.scrollTo({ left: n * el.clientWidth, behavior: 'smooth' }); }); })(i); dots.appendChild(d); }
      }
      var cur = Math.round(el.scrollLeft / el.clientWidth);
      if (el.scrollLeft + el.clientWidth >= el.scrollWidth - 4) cur = pages - 1;
      [].forEach.call(dots.children, function (d, i) { d.setAttribute('aria-current', i === cur ? 'true' : 'false'); });
    }
    el.addEventListener('scroll', function () { requestAnimationFrame(build); }, { passive: true });
    window.addEventListener('resize', build); build(); setTimeout(build, 1500);
  }

  // Drag-to-scroll with a mouse (touch already swipes natively)
  function setupDrag(el) {
    if (el.__drag) return; el.__drag = true;
    var down = false, moved = false, sx = 0, sl = 0;
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (e.target.closest('button, a, input, video[controls], .tv-reel__play')) return;
      down = true; moved = false; sx = e.clientX; sl = el.scrollLeft; el.classList.add('is-dragging');
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return; var dx = e.clientX - sx; if (Math.abs(dx) > 4) moved = true; el.scrollLeft = sl - dx;
    });
    window.addEventListener('pointerup', function () { if (!down) return; down = false; el.classList.remove('is-dragging'); });
    el.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    el.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  // Details & FAQ: tabs on desktop, dropdowns on mobile
  var mq = window.matchMedia('(max-width: 749px)');
  function detailsMode() {
    document.querySelectorAll('[data-tv-tabs]').forEach(function (root) {
      var panels = root.querySelectorAll('details.tv-dpanel'); if (!panels.length) return;
      if (mq.matches) {
        panels.forEach(function (p) { p.hidden = false; if (!p.__mInit) { p.open = !p.hasAttribute('data-closed-mobile'); p.__mInit = true; } });
      } else {
        var sel = root.querySelector('[data-tv-tab][aria-selected="true"]');
        panels.forEach(function (p, i) { p.open = true; p.hidden = sel ? p.id !== sel.getAttribute('aria-controls') : i > 0; });
      }
    });
  }
  if (mq.addEventListener) mq.addEventListener('change', detailsMode);
  document.addEventListener('click', function (e) { if (e.target.closest('.tv-dsum') && !mq.matches) e.preventDefault(); });

  // Thin gradient scroll indicator (comparison table)
  function setupBar(bar) {
    if (bar.__bar) return; bar.__bar = true;
    var el = bar.previousElementSibling, thumb = bar.firstElementChild; if (!el) return;
    function upd() {
      var max = el.scrollWidth - el.clientWidth; bar.hidden = max < 4; if (max < 4) return;
      var w = el.clientWidth / el.scrollWidth * 100; thumb.style.width = w + '%';
      thumb.style.left = (el.scrollLeft / max) * (100 - w) + '%';
    }
    el.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
    window.addEventListener('resize', upd); upd(); setTimeout(upd, 1200);
    // drag the bar itself too
    var down = false, sx = 0, sl = 0;
    bar.addEventListener('pointerdown', function (e) { down = true; sx = e.clientX; sl = el.scrollLeft; bar.setPointerCapture(e.pointerId); });
    bar.addEventListener('pointermove', function (e) { if (!down) return; el.scrollLeft = sl + (e.clientX - sx) * (el.scrollWidth / el.clientWidth); });
    bar.addEventListener('pointerup', function () { down = false; });
  }
  // Mobile dropdowns: only one open at a time (fallback for browsers without details[name])
  document.addEventListener('toggle', function (e) {
    var d = e.target; if (!d.classList || !d.classList.contains('tv-dpanel') || !d.open || !mq.matches) return;
    d.parentElement.querySelectorAll('details.tv-dpanel[open]').forEach(function (o) { if (o !== d) o.open = false; });
  }, true);

  function bootUI() { document.querySelectorAll('[data-tv-scrollbar]').forEach(setupBar); document.querySelectorAll('[data-tv-dots]').forEach(setupDots); document.querySelectorAll('.tv-reel, .tv-cmp__imgs, .tv-scroller, .tv-table-wrap, .tv-carousel__track, .tv-prod__thumbs').forEach(setupDrag); detailsMode(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootUI); else bootUI();
  document.addEventListener('shopify:section:load', bootUI);

  // Order countdown (5 PM Pacific cut-off, Mon-Fri)
  function ptNow() { return new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Vancouver' })); }
  function tick() {
    document.querySelectorAll('[data-tv-timer]').forEach(function (el) {
      var tail = el.getAttribute('data-tail') || '';
      var n = ptNow(), d = n.getDay(), h = n.getHours();
      if (d === 0 || d === 6) { el.innerHTML = 'Place your order <strong>now</strong> to be processed on Monday. ' + tail; return; }
      if (h < 17) {
        var dl = new Date(n); dl.setHours(17, 0, 0, 0);
        var diff = dl - n, m = Math.floor(diff / 60000 % 60), hr = Math.floor(diff / 3600000);
        var t = hr > 0 ? hr + 'h ' + m + 'm' : m + ' minute' + (m !== 1 ? 's' : '');
        el.innerHTML = 'Place your order in the next <strong><span class="t' + (diff <= 3600000 ? ' red' : '') + '">' + t + '</span></strong> for same-day processing. ' + tail;
        return;
      }
      el.innerHTML = 'Place your order <strong>now</strong> to be processed ' + (d === 5 ? 'on Monday' : 'tomorrow') + '. ' + tail;
    });
  }
  // (order timer now lives in the product section)

  // Floating video + scroll to top
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-tv-float-close]');
    if (c) { var f = c.closest('.tv-float'); f.querySelectorAll('video').forEach(function (fv) { fv.pause(); fv.muted = true; fv.removeAttribute('autoplay'); }); f.classList.remove('is-big'); f.classList.add('is-hidden'); try { sessionStorage.setItem('tvFloatClosed', '1'); } catch (_) {} return; }
    var v = e.target.closest('.tv-float video');
    if (v) { var box = v.closest('.tv-float'); var big = box.classList.toggle('is-big'); v.muted = !big; if (big) { v.currentTime = 0; v.play(); } }
    if (e.target.closest('[data-tv-totop]')) window.scrollTo({ top: 0, behavior: 'smooth' });
  });
  try { if (sessionStorage.getItem('tvFloatClosed')) document.documentElement.classList.add('tv-float-closed'); } catch (_) {}
  var toTopLim = null;
  function toTop() {
    if (toTopLim === null) { var hero = document.querySelector('.tv-hero'); toTopLim = hero ? hero.getBoundingClientRect().bottom + window.scrollY - 80 : 400; }
    var on = window.scrollY > toTopLim;
    document.querySelectorAll('[data-tv-totop]').forEach(function (b) { if (b.classList.contains('is-on') !== on) b.classList.toggle('is-on', on); });
  }
  window.addEventListener('scroll', toTop, { passive: true });
  window.addEventListener('resize', function () { toTopLim = null; toTop(); });
})();

/* Product form */
(function () {
  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    return (fmt || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/, v).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100)).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ','));
  }
  function init(root) {
    if (root.__tv) return; root.__tv = true;
    var data = JSON.parse(root.querySelector('[data-tv-product-json]').textContent);
    var variants = data.variants, fmt = data.money_format;
    var main = root.querySelector('[data-tv-main]');
    var thumbs = root.querySelectorAll('[data-tv-thumb]');
    var idInput = root.querySelector('[name="id"]');
    var priceEl = root.querySelector('[data-tv-price]');
    var err = root.querySelector('[data-tv-err]');
    var btns = root.querySelectorAll('[data-tv-add]');

    function show(i) {
      var t = thumbs[i]; if (!t) return;
      thumbs.forEach(function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
      var tpl = t.querySelector('template');
      main.innerHTML = tpl ? tpl.innerHTML : '';
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });

    function selected() {
      return data.options.map(function (_, i) { var c = root.querySelector('input[data-opt="' + i + '"]:checked'); return c ? c.value : null; });
    }
    function find(sel) {
      if (!root.querySelector('input[data-opt]')) return variants.find(function (v) { return v.available; }) || variants[0];
      return variants.find(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); });
    }
    function refresh(changed) {
      var sel = selected();
      var v = find(sel);
      if (!v && changed != null) {
        // pick the first available variant matching the option just changed
        v = variants.find(function (x) { return x.available && x.options[changed] === sel[changed]; }) || variants.find(function (x) { return x.options[changed] === sel[changed]; });
        if (v) v.options.forEach(function (o, i) { var r = root.querySelector('input[data-opt="' + i + '"][value="' + CSS.escape(o) + '"]'); if (r) r.checked = true; });
        sel = selected();
      }
      // hide option values that don't exist with the options chosen before them (e.g. band colours for the chosen material + case)
      root.querySelectorAll('input[data-opt]').forEach(function (inp) {
        var i = +inp.dataset.opt;
        var exists = variants.some(function (x) { return x.options[i] === inp.value && x.options.every(function (o, k) { return k >= i || o === sel[k]; }); });
        var avail = variants.some(function (x) { return x.available && x.options[i] === inp.value && x.options.every(function (o, k) { return k >= i || o === sel[k]; }); });
        var last = i === data.options.length - 1;
        var wrap = inp.closest('[data-val]'); if (wrap) wrap.hidden = last && !exists;
        inp.disabled = !last && !exists;
        inp.classList.toggle('is-na', !last && !exists);
        inp.classList.toggle('is-unavailable', exists && !avail);
      });
      data.options.forEach(function (_, i) { var l = root.querySelector('[data-opt-label="' + i + '"]'); if (l) l.textContent = sel[i] || ''; });
      if (!v) { idInput.value = ''; btns.forEach(function (b) { b.disabled = true; }); err.textContent = 'This combination is unavailable.'; return; }
      if (idInput.value != v.id) { idInput.value = v.id; idInput.dispatchEvent(new Event('change', { bubbles: true })); }
      err.textContent = '';
      btns.forEach(function (b) { b.disabled = !v.available; b.querySelector('span').textContent = v.available ? b.dataset.label : 'Sold out'; });
      var was = v.compare_at_price || 0, shown = v.price;
      if (data.sale_pct > 0) { shown = v.price - Math.round(v.price * data.sale_pct / 100); was = Math.max(was, v.price); }
      priceEl.innerHTML = money(shown, fmt) + (was > shown ? ' <s class="tv-was">' + money(was, data.money_plain || fmt) + '</s>' : '');
      if (v.featured_media) { thumbs.forEach(function (t, i) { if (+t.dataset.mediaId === v.featured_media.id) show(i); }); }
      if (root.dataset.updateUrl === 'true' && history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
    }
    root.querySelectorAll('input[data-opt]').forEach(function (inp) { inp.addEventListener('change', function () { refresh(+inp.dataset.opt); }); });

    var q = root.querySelector('[name="quantity"]');
    root.querySelectorAll('[data-tv-qty]').forEach(function (b) { b.addEventListener('click', function () { q.value = Math.max(1, (+q.value || 1) + (+b.dataset.tvQty)); }); });

    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        if (!idInput.value) return;
        btns.forEach(function (x) { x.disabled = true; });
        var drawer = b.dataset.redirect === 'drawer' ? document.querySelector('cart-drawer') : null;
        var body = { items: [{ id: +idInput.value, quantity: Math.max(1, +q.value || 1) }] };
        if (drawer) { body.sections = ['cart-drawer', 'cart-icon-bubble']; body.sections_url = window.location.pathname; }
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
          .then(function (j) {
            if (b.dataset.redirect === 'drawer') {
              if (drawer && j.sections && drawer.renderContents) {
                j.id = +idInput.value;
                /* like Dawn's own add-to-cart: clear the drawer's 'empty cart' state first,
                   otherwise the header and items stay hidden when the cart started empty */
                drawer.classList.remove('is-empty');
                drawer.renderContents(j);
                btns.forEach(function (x) { x.disabled = false; });
              } else { window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart'; }
              return;
            }
            window.location.href = b.dataset.redirect;
          })
          .catch(function (e) { err.textContent = (e && (e.description || e.message)) || 'Something went wrong. Please try again.'; btns.forEach(function (x) { x.disabled = false; }); });
      });
    });
    refresh(null);
    var row = root.querySelector('[data-tv-thumbrow]');
    if (row) {
      var tr = row.querySelector('.tv-prod__thumbs');
      var fit = function () { row.classList.toggle('is-fit', tr.scrollWidth <= tr.clientWidth + 2); };
      fit(); window.addEventListener('resize', fit); window.addEventListener('load', fit);
    }
  }
  function boot() { document.querySelectorAll('[data-tv-product]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

/* Background (muted, looping) videos: make sure they play on iPhone.
   iOS can skip autoplay (e.g. Low Power Mode or when the video starts off-screen),
   so play them when they scroll into view and again on the first tap/scroll. */
(function () {
  function bgVideos() { return [].slice.call(document.querySelectorAll('video[autoplay][muted], video[autoplay][loop]')); }
  function kick(v) { if (v.closest('.tv-float.is-hidden, .tv-float-closed') || !v.hasAttribute('autoplay')) return; if (v.paused) { v.muted = v.muted !== false ? v.muted : true; var p = v.play(); if (p && p.catch) p.catch(function () {}); } }
  function init() {
    var vids = bgVideos(); if (!vids.length) return;
    vids.forEach(function (v) { v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', ''); if (v.hasAttribute('muted')) v.muted = true; });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) kick(e.target); }); }, { threshold: 0.15 });
      vids.forEach(function (v) { io.observe(v); });
    } else { vids.forEach(kick); }
    var once = function () { bgVideos().forEach(function (v) { var r = v.getBoundingClientRect(); if (r.bottom > 0 && r.top < innerHeight) kick(v); }); };
    ['touchstart', 'scroll', 'click'].forEach(function (ev) { window.addEventListener(ev, once, { passive: true }); });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) once(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Announcement bar "Join TreviTribe" link: if this page has its own signup form (#join),
   point the bar's link at that form instead of the home page's. Pages without one keep the home-page link. */
(function () {
  function fix() {
    if (!document.getElementById('join')) return;
    document.querySelectorAll('.announcement-bar a[href*="#join"], .utility-bar a[href*="#join"]').forEach(function (a) { a.setAttribute('href', '#join'); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fix); else fix();
  document.addEventListener('shopify:section:load', fix);
})();
